import { IonContent, IonPage, IonGrid, IonRow, IonCol } from '@ionic/react';
import React, { useState } from 'react';

import EditEventContainer from '../components/EditEventContainer';

let initted = false;

const EditEvent: React.FC = () => {
  
  const [wideScreenMode, setWideScreenMode] = useState(false);

  if (!initted) {
    initted = true;

    if (window.innerWidth > 800) {
      setWideScreenMode(true);
    }
  }

  return (
    <IonPage>
      {/* <IonHeader>
        <IonToolbar>
            <IonButton href="/Profile" disabled>
              <IonIcon className="topicon" src="assets/icon/profile-on.svg" />
            </IonButton>
            <IonButton disabled>
            <IonIcon className="topicon" src="assets/icon/events.svg" />
            </IonButton>
            <IonButton href="/Home" disabled>
              <IonIcon slot="icon-only" src="assets/icon/swipe.svg" />
            </IonButton>
            <IonButton disabled>
              <IonIcon slot="icon-only" src="assets/icon/chat.svg" />
            </IonButton>
        </IonToolbar>
    </IonHeader> */}
      <IonContent>
      {wideScreenMode? (
        <IonGrid>
          <IonRow>
          <IonCol className="sideCol" size="1"></IonCol>
            <IonCol className="mainCol" size="10">
              <div className="mainDiv">
              <EditEventContainer/>
              </div>
            </IonCol>
             <IonCol className="sideCol" size="1"></IonCol>
          </IonRow>
        </IonGrid>
                ):(
                  <div>
                  <EditEventContainer/>
                </div>
                )}
      </IonContent>
    </IonPage>
  );
};

export default EditEvent;
